import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import usePostSaveAuthorizedIPs from '../../../../hooks/useApi/usePostSaveAuthorizedIPs';
import useFetchAuthorizedIPs from '../../../../hooks/useApi/useFetchAuthorizedIPs';
import UpdateAuthorizedIpsForm from './UpdateAuthorizedIpsForm';
import UpdateAuthorizedIpsReview from './UpdateAuthorizedIpsReview';
import UpdateAuthorizedIpsContext, { UpdateAuthorizedIpsCtx } from './Dialogue/UpdateAuthorizedIpsContext';
import UpdateAuthorizedIpsDialogue from './Dialogue/UpdateAuthorizedIpsDialogue';
import { UpdateAuthorizedIpsDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import { useClientData } from '../../../../providers/ClientData.provider';

type FC = FunctionComponent;

const UpdateAuthorizedIpsContainer: FC = () => {
  const history = useHistory();
  const [UpdateError, setUpdateError] = useState('');
  const [showUpdateErrorAlert, setShowUpdateErrorAlert] = useState(false);
  const [showUpdateSuccessAlert, setShowUpdateSuccessAlert] = useState(false);
  const [shouldUpdateAuthorizedIps, setShouldUpdateAuthorizedIps] = useState(false);
  const [setAuthorizedIpsResponse, setAuthorizedIps] = usePostSaveAuthorizedIPs({});
  const [authorizedIPs, getAuthorizedIPs] = useFetchAuthorizedIPs({});

  const [review, setReview] = useState(false);
  const { response } = useClientData();
  const [AuthorizedIpsRequest, setAuthorizedIpsRequest] = useState<vp.SaveAuthorizedIPsRequest>({
    AuthorizedIPs: '',
    PortalUser: response.LoginUserName,
  });

  const UpdateAuthorizedIps: UpdateAuthorizedIpsCtx = {
    showUpdateSuccessAlert,
    showUpdateErrorAlert,
    UpdateError,
  };
  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<UpdateAuthorizedIpsDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: UpdateAuthorizedIpsDialogueHandler = {
        update: {
          success: {
            default: () => {
              setShowUpdateSuccessAlert(false);
              history.push('/settings/authorized-ips');
            },
          },
          error: {
            default: () => {
              setShowUpdateErrorAlert(false);
              setUpdateError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onReview: (values: vp.SaveAuthorizedIPsRequest) => {
      setReview(true);
      setAuthorizedIpsRequest(values);
    },
    onUpdate: (values: vp.SaveAuthorizedIPsRequest) => {
      setShouldUpdateAuthorizedIps(true);

      setAuthorizedIps(values);
    },
    onBack: () => {
      setReview(false);
    },
  };
  useEffect(() => {
    getAuthorizedIPs({
      PortalUser: response.LoginUserName,
    });
  }, []);
  useEffect(() => {
    if (authorizedIPs?.Success === true) {
      setAuthorizedIpsRequest({
        AuthorizedIPs: authorizedIPs.AuthorizedIPs,
        PortalUser: response.LoginUserName,
      });
    }
  }, [authorizedIPs]);
  useEffect(() => {
    if (shouldUpdateAuthorizedIps) {
      setShouldUpdateAuthorizedIps(false);

      if (setAuthorizedIpsResponse?.Success === true) {
        setShowUpdateSuccessAlert(true);
      } else {
        setUpdateError(setAuthorizedIpsResponse?.ErrorMessage || '');
        setShowUpdateErrorAlert(true);
      }
    }
  }, [setAuthorizedIpsResponse]);

  return (
    <UpdateAuthorizedIpsContext.Provider value={UpdateAuthorizedIps}>
      {!review && <UpdateAuthorizedIpsForm defaultValues={AuthorizedIpsRequest} onSubmit={handlers.onReview} />}
      {review && (
        <UpdateAuthorizedIpsReview
          defaultValues={AuthorizedIpsRequest}
          onSubmit={handlers.onUpdate}
          onBack={handlers.onBack}
        />
      )}
      <UpdateAuthorizedIpsDialogue handleDialogue={handlers.handleDialogue} />
    </UpdateAuthorizedIpsContext.Provider>
  );
};

export default UpdateAuthorizedIpsContainer;
